import { CFBaseButtonTokens } from '.';
export const getIconColor = ({ disabled, variant = 'primary' }, iconOnly = false) => {
    if (disabled) {
        return CFBaseButtonTokens.COLORS.TEXT_DISABLED[variant];
    }
    if (variant === 'standalone' && iconOnly) {
        return CFBaseButtonTokens.COLORS.TEXT['standalone-icon-only'];
    }
    if (variant === 'standalone-alternate' && iconOnly) {
        return CFBaseButtonTokens.COLORS.TEXT['standalone-icon-only-alternate'];
    }
    return CFBaseButtonTokens.COLORS.TEXT[variant];
};
export const getIconSize = (size = 'md') => CFBaseButtonTokens.ICON_SIZE[size];
export const isVariantStandaloneType = (variant) => variant === 'standalone' ||
    variant === 'standalone-emphasis' ||
    variant === 'standalone-alternate';
